import { mapState } from 'vuex';
export default {
  name: 'ViewError',
  data: function () {
    return {
      bg: 'background-image: url(./img/error.jpg);background-size: cover;'
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])
  },
  methods: {
    getBG() {
      switch (this.CustomTheme) {
        default:
          return this.bg;
      }
    }
  }
};